import { useFormState } from 'utils/hooks';
import Input from 'common/components/form/styled-inputs/Input';
import { FormState } from 'common/entities/form/FormTypes';

const Group = ({ formState }) => {
  const { fields, changeField } = useFormState(formState);

  return (
    <div className="d-flex flex-column">
      <Input
        label="Code"
        invisible={false}
        placeholder={'Add code'}
        className="mb-2 mt-1"
        onChange={changeField('code')}
        {...fields.code}
      />

      <Input
        label="Name"
        invisible={false}
        placeholder={'Add name'}
        onChange={changeField('name')}
        {...fields.name}
      />
    </div>
  );
};

export default Group;

Group.propTypes = {
  formState: FormState
};
